module.exports = __webpack_public_path__ + "c2afc11f7a7ddd3eea0c50830d241f0e.pdf";